<template>
    <div class="question-input-type">
        <div v-if="hasError">
            <b-alert show variant="danger">{{ errorText }}</b-alert>
        </div>
        <b-form-group
            id="custom-form-question-input"
            label-for="custom-form-question-input">
            <template v-slot:label>
                {{ questionIn.text }}: <span class="required" v-if="questionIn.required">*</span>
            </template>

            <b-form-input
                v-if="type"
                id="custom-form-question-input"
                :type="type"
                :value="value"
                @input="update">
            </b-form-input>

        </b-form-group>
    </div>
</template>

<script>
export default {
    name: "custom-form-create-question-input-component",
    props: {
        questionIn: {
            type: Object,
            required: true,
        },
        hasError: {
          type: Boolean,
          required: false,
          default: false,
        },
        errorText: {
            type: String,
            required: false,
            default: 'Deze vraag is verplicht.'
        },
        value: {
            type: String,
        }
    },
    methods:{
        update(input){
            this.$emit('update-answer', {
                questionId: this.questionIn.id,
                value: input,
                isEmpty: !input,
                type: 1
            });
        }
    },
    computed: {
        type() {
            const email_ids = [8, 19, 28]
            if (email_ids.includes(this.questionIn.id)) {
                return 'email';
            }

            if (this.questionIn.id === 10) {
                return 'number'
            }

            return 'text';
        }
    }
}
</script>

<style scoped>

</style>
